import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../config/config";
import axiosInstance from "../../../interceptors";

const post = (path) => (payload) => axiosInstance.post(`${baseUrl}/job-posting/api/email${path}`, payload);

const make = (name, path) => createAsyncThunk(name, async (payload, { rejectWithValue }) => {
  try {
    const { data } = await post(path)(payload);
    if (data.success) return data.data;
    return rejectWithValue(data.message);
  } catch (error) { return rejectWithValue(error.message); }
});

export const emailGetConfig = make("email/config/get", "/config/get");
export const emailSaveConfig = make("email/config/save", "/config/save");
export const emailSendTest = make("email/send-test", "/send-test");
export const emailListEvents = make("email/events/list", "/events/list");
export const emailStats = make("email/stats", "/stats");
